import { FaWhatsapp } from 'react-icons/fa';

const WhatsappIcon = ({ number, message } = { number: '', message: '' }) => {
  const phoneNumber = (number || '').replace(/[^\d]/g, '');
  const text = message;
  const href = `https://wa.me/${phoneNumber}${text ? `?text=${encodeURIComponent(text)}` : ''}`;

  return (
    <>
      <style>{`
        @keyframes whatsapp-pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6),
                        0 6px 16px rgba(0, 0, 0, 0.25);
          }
          70% {
            box-shadow: 0 0 0 18px rgba(37, 211, 102, 0),
                        0 6px 16px rgba(0, 0, 0, 0.25);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0),
                        0 6px 16px rgba(0, 0, 0, 0.25);
          }
        }

        @keyframes whatsapp-float-in {
          from {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .whatsapp-floating-btn {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          z-index: 9999;
          cursor: pointer;
          animation: whatsapp-float-in 0.4s ease-out,
                     whatsapp-pulse 2.2s ease-out 0.4s infinite;
          transition: transform 0.25s ease, background 0.25s ease;
        }

        .whatsapp-floating-btn:hover {
          transform: scale(1.1) rotate(-6deg);
          background: linear-gradient(135deg, #2EE070 0%, #149E8E 100%);
        }

        .whatsapp-floating-btn:active {
          transform: scale(0.95);
        }

        .whatsapp-floating-btn svg {
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
        }

        @media (max-width: 480px) {
          .whatsapp-floating-btn {
            width: 52px;
            height: 52px;
            bottom: 16px;
            right: 16px;
          }
          .whatsapp-floating-btn svg {
            width: 32px;
            height: 32px;
          }
        }
      `}</style>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-floating-btn"
        aria-label="Chat on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp size={36} />
      </a>
    </>
  );
};
export default WhatsappIcon;
